module.exports = __webpack_public_path__ + "static/media/search-icon.24c8d2eb.svg";